import { InjectionToken } from '@angular/core';
import { Environment } from '@core/models/environment.models';

export const ENVIRONMENT: InjectionToken<Environment> = new InjectionToken('ENVIRONMENT');
